<template>
  <v-card
    :style="`position: sticky; top: ${offsetTop}px; z-index: 10;`"
  >
    <v-container style="position: relative;">
      <v-layout
        px-3
        align-center
      >
        <v-flex
          xs3
        >
          <GroupSelect
            :value="area"
            label="エリア"
            :group="group"
            :disable-company="true"
            @input="setArea"
          />
        </v-flex>
        <div
          class="d-flex ml-3"
          style="position:relative"
        >
          <SpeechBubbleCondition />
          <SearchField />
          <SensorStateFilter />
        </div>
        <Fieldset @show-map="showMap = true" />
        <DialogBox
          v-model="showMap"
        >
          <MapCard v-if="showMap" />
        </DialogBox>
      </v-layout>
      <Options />
    </v-container>
  </v-card>
</template>
<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import { DialogBox } from '@/components/dialog'
import { GroupSelect } from '@/components/input'
import { SpeechBubbleCondition, Fieldset, SearchField, SensorStateFilter, Options } from './DeliveryCondition/index'

export default {
  components: {
    GroupSelect,
    SpeechBubbleCondition,
    Fieldset,
    DialogBox,
    MapCard: () => import('./DeliveryCondition/Map/MapCard'),
    SearchField,
    SensorStateFilter,
    Options
  },
  data () {
    return {
      showMap: false
    }
  },
  computed: {
    ...mapState('groups', ['group']),
    ...mapState('display', ['offsetTop']),
    ...mapState('list', ['area', 'caseNumberInput']),
    ...mapGetters('list', ['selectedNum'])
  },
  methods: {
    ...mapActions('list', ['setArea'])
  }
}
</script>

<style lang="scss" scoped>
/deep/ .v-messages {
  min-height: 0;
}
</style>
